export default __webpack_public_path__ + "static/media/community-all-house.778aff6b.png";